import styled from 'styled-components';

const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  max-width: 440px;

  transition: 0.3s;

  flex: 1;

  @media (max-width: ${props => props.theme.layout.breakpoints.md}) {
    padding: 2rem;
    margin: 0 -2rem -2rem;
    max-width: initial;

    background-color: ${props => props.theme.palette.neutral[100]};
  }
`;

export default SummaryColumn;
